import * as React from 'react';
import * as styles from './Section.css';

interface ISectionProps {
  title?: string;
  dataName?: string;
}

export const Section: React.FC<React.PropsWithChildren<ISectionProps>> = ({ children, title, dataName }) => {
  return (
    <div className={styles['section']} data-name={dataName}>
      {title && <h2 className={styles['title']}>{title}</h2>}
      {children}
    </div>
  );
};
